// components/layout/services-ui/links-panel.jsx
'use client';

import Link from 'next/link';

export default function LinksPanel({ isLight, category, onLinkClick, closeDropdown }) {
    const safeHref = (href) => (href?.startsWith('/') ? href : `/${href}`);

    const panelText = isLight ? 'text-slate-900' : 'text-white';
    const mutedText = isLight ? 'text-slate-500' : 'text-slate-400';
    const linkText = isLight
        ? 'text-slate-600 hover:text-primary'
        : 'text-slate-300 hover:text-blue-300';

    if (!category) return null;

    return (
        <div className="rounded-xl p-4">
            <div className="flex items-center justify-between mb-3">
                <div>
                    <p className={`text-sm font-semibold ${panelText}`}>{category.title}</p>
                    {/* <p className={`text-xs ${mutedText}`}>Pick a service to learn more</p> */}
                </div>

                {/* <Link
                    href={safeHref(category.url || '/services')}
                    onClick={() => closeDropdown()}
                    className={`text-sm font-semibold ${panelText} ${isLight ? 'hover:text-primary' : 'hover:text-blue-300'}`}
                >
                    View all
                </Link> */}
            </div>

            <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
                {category.links.map(([text, slug]) => (
                    <li key={slug}>
                        <Link
                            href={safeHref(slug)}
                            onClick={() => {
                                closeDropdown();
                                onLinkClick?.();
                            }}
                            className={`text-sm transition-colors ${linkText}`}
                        >
                            {text}
                        </Link>
                    </li>
                ))}
            </ul>

            <div
                className={`mt-4 pt-4 border-t ${isLight ? 'border-slate-200' : 'border-slate-800'} flex items-center justify-between`}
            >
                <Link
                    href="/contact-us"
                    onClick={() => closeDropdown()}
                    className={`text-sm font-semibold ${panelText} ${isLight ? 'hover:text-primary' : 'hover:text-blue-300'}`}
                >
                    Get a quote →
                </Link>

                <span className={`text-xs ${mutedText}`}>Quick response • No obligation</span>
            </div>
        </div>
    );
}
